// extracted by mini-css-extract-plugin
export default {"appButton":"app-button_appButton__Lc2KB"};